import { FinanceiroLabels } from "@/lib/labels/financeiro";
import { format } from "@/lib/format";
import { cn } from "@/lib/utils";
import type { CashCount } from "@/types/financeiro";

export function CashCounts({ counts }: { counts: CashCount[] }) {
	if (counts.length === 0) {
		return null;
	}

	return (
		<div className="mt-4 border-t border-border pt-4">
			<h3 className="text-sm font-semibold text-foreground">Contagens</h3>
			<ul className="mt-2 grid gap-2">
				{counts.map((count) => (
					<li key={count.id} className="rounded-lg bg-secondary/50 p-3">
						<div className="flex flex-wrap items-center justify-between gap-2">
							<p className="text-xs font-medium text-foreground">{count.author}</p>
							<p className="text-xs text-muted-foreground">{format.dateTime(count.created_at)}</p>
						</div>
						<div className="mt-2 grid gap-2 sm:grid-cols-3">
							<div>
								<p className="text-xs text-muted-foreground">Esperado</p>
								<p className="font-mono text-xs font-semibold text-foreground">
									{FinanceiroLabels.money(count.expected_cents)}
								</p>
							</div>
							<div>
								<p className="text-xs text-muted-foreground">Contado</p>
								<p className="font-mono text-xs font-semibold text-foreground">
									{FinanceiroLabels.money(count.counted_cents)}
								</p>
							</div>
							<div>
								<p className="text-xs text-muted-foreground">Diferença</p>
								<p
									className={cn(
										"font-mono text-xs font-semibold",
										count.difference_cents === 0 ? "text-foreground" : "text-warning",
									)}
								>
									{FinanceiroLabels.signed(count.difference_cents)}
								</p>
							</div>
						</div>
					</li>
				))}
			</ul>
		</div>
	);
}
